import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Layout } from "antd";

import { BackButton } from "../../uiMerge/backButton";

// import * as ROUTES from "../../constants/routes";
// let { Header } = Layout;

interface Props {
  // navMenu: any;
  // currentPage: number;
  pageTitle: string;
  hasComponent: boolean;
  component: React.ReactNode;
  icon: React.ReactNode;
  isCentered: boolean;
}

// class C extends React.PureComponent<Props> {
const C: React.FC<Props> = ({
  pageTitle,
  hasComponent,
  component,
  isCentered = true,
  icon,
}) => {
  useEffect(() => {
    document.title = pageTitle;
    return () => {
      document.title = "Njoy"; // or your default
    };
  }, [pageTitle]);

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/"; // fallback to home if no history
    }
  };

  return (
    <div className="flex justify-between items-center px-[1rem] pb-[1rem] mt-12 ">
      <div className="flex flex-shrink-0">
        <BackButton onClick={handleBack} />
      </div>
      <div>
        {hasComponent ? (
          <div className="mx-auto w-full">{component}</div>
        ) : (
          <p className="text-[20px] font-extrabold text-center mx-auto text-white">
            {pageTitle}
          </p>
        )}
      </div>

      <div>
        {isCentered && (
          <div className="w-[44px] h-[44px] flex justify-center items-center ">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export const HeaderAlt = C;
